module.exports = __webpack_public_path__ + "img/61_6.98178c10.png";